import type { ReactElement } from 'react'
import type { ContactCardFacts } from 'app/components/lists/card/contactCardFacts'
import Tag from 'app/components/tags/Tag'

export function TagsSection({
  derived,
  workspaceId,
}: {
  derived: ContactCardFacts
  workspaceId?: string
}): ReactElement | null {
  const { tags } = derived
  if (tags.shown.length === 0) return null
  return (
    <div className="mt-1.5 flex flex-wrap items-center gap-1">
      {tags.shown.map((tag) => (
        <Tag
          key={tag}
          workspaceId={workspaceId}
          model="contacts"
          tag={tag}
          readOnly
          tagClassName="text-body-xs leading-4"
          removeTag={() => {}}
        />
      ))}
      {tags.extra > 0 && <span className="text-body-xs text-minimal">+{tags.extra}</span>}
    </div>
  )
}
